<script lang="ts">
const USER_ADDON_ID = 'user'
const SEATS_INCLUDED_IN_SUBSCRIPTION_BY_DEFAULT = 1
</script>
<script setup lang="ts">
withDefaults(defineProps<{
  disabled?: boolean
}>(), {  })

const {
  paymentPeriodUnit,
  priceList,
  addons,
} = useSubscriptionProcessContext()

const { t } = useI18n()
const { formatCurrency } = useIntl()




const userAddon = computed(() => priceList.data.value?.addons.find(addon => addon.addon_id === USER_ADDON_ID))
const userAddonPriceByPeriod = computed(() => userAddon.value?.prices.find(({ period_unit }) => period_unit === paymentPeriodUnit.value))
const userAddonPriceFormatted = computed(() => formatCurrency((userAddonPriceByPeriod.value?.monthly_price ?? 0) / 100, { minimumFractionDigits: 0, maximumFractionDigits: 2 }))

const internalQuantity = ref(SEATS_INCLUDED_IN_SUBSCRIPTION_BY_DEFAULT)

const handleQuantityUpdate = (val: number) => {
  const quantity = val - SEATS_INCLUDED_IN_SUBSCRIPTION_BY_DEFAULT
  addons.value = quantity <= 0
    ? addons.value.filter(addon => addon.addonId !== USER_ADDON_ID)
    : [...addons.value.filter(addon => addon.addonId !== USER_ADDON_ID), { addonId: USER_ADDON_ID, quantity }]
}
</script>

<template>
  <div class="flex items-center justify-between gap-2 rounded-lg border border-gray-300 p-3.5 font-semibold">
    <span>{{ userAddonPriceFormatted }} {{ t('subscribe.plans.userAddon.priceLine') }}</span>
    <BaseNumberInputOffsettable
      v-if="userAddon"
      v-model="internalQuantity"
      :min="SEATS_INCLUDED_IN_SUBSCRIPTION_BY_DEFAULT"
      :disabled="disabled"
      @update:model-value="handleQuantityUpdate"
    />
  </div>
</template>
